import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { IvftSupplementationRedLabelInstructions } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-ivtf-supplementation-red-label-item',
    templateUrl: './ivft-supplementation-red-label-item.component.html',
    styleUrl: './ivft-supplementation-red-label-item.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvftSupplementationRedLabelItemComponent implements SheetItemComponentBase {

	row!: Row;
	instructions!: IvftSupplementationRedLabelInstructions;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as IvftSupplementationRedLabelInstructions;
	}

	constructor() {
	}
}